import React from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import './Sidebar.css';
import '../../localization/localizationService'

/**
 * Sidebar View displaying callable routes linked to navlinks
 * @param {any} props not used at the moment
 */
const Side = props => {
    return (
        <Nav className="col-md-12 d-inline sidebar">
            <div className="sidebar-sticky">
                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/incoming-transactions">&#x25b8;{window.i18n('inbox')}</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/outgoing-transactions">&#x25b8;{window.i18n('outbox')}</Nav.Link>
                </Nav.Item>

                <NavDropdown className="nav-drop dark-link" title={window.i18n('storageLink')} >
                    <Nav.Item>
                        <Nav.Link as={Link} className="text-dark" to="/articles">&#x25b8;{window.i18n('articleTypes')}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link as={Link} className="text-dark" to="/inventory">&#x25b8;{window.i18n('stock')}</Nav.Link>
                    </Nav.Item>
                </NavDropdown>

                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/transaction-archive">&#x25b8;{window.i18n('deliveryArchive')}</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/sales-report">&#x25b8;{window.i18n('salesReport')}</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/b2c-orders">&#x25b8;{window.i18n('b2cOrders')}</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item>*/}
                {/*    <Nav.Link as={Link} className="text-dark" to="/sales">&#x25b8;Verkäufe</Nav.Link>*/}
                {/*</Nav.Item>*/}
            </div>
        </Nav>
    );
};

const Sidebar = withRouter(Side);

export default Sidebar